// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAEtJREFUKFOF0NEJACAIBFDbQ/cfTPe4MDCiNO9THio3AICamBmNDjpi5j8M5AfLjScq4Y1SmKEHOhKR9J09rDZFcwt2aJ1WVXhPXSYTRUaPHj5D3QAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-block .upload-container {
  margin: 0 0.5rem;
  display: block;
  border: 2px solid rgb(200, 200, 200);
  border-radius: 0.5rem;
  background: rgb(255, 255, 255);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.image-block .upload-container .upload-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
}

.image-block .upload-container .upload-dropzone .upload-dropzone-picture {
  background: rgba(255, 255, 255, 0.8);
  padding: 0.25rem 0.5rem;
  color: rgb(100, 100, 100);
}

.image-block .upload-container .upload-dropzone .upload-dropzone-picture svg {
  width: 2rem;
}

.image-block .upload-container .upload-dropzone .upload-dropzone-text {
  background: rgba(255, 255, 255, 0.8);
  padding: 0.25rem 0.5rem;
}

.image-block .upload-container .upload-element {
  display: none;
}

.image-block .image-container {
  display: flex;
  align-items: center;
}

.image-block .image-container.stretched .image-element {
  width: 100%;
}

.aligner--align-left .image-container {
  justify-content: start;
}

.aligner--align-center .image-container {
  justify-content: center;
}

.aligner--align-right .image-container {
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./assets/js/components/editorjs/components/block-image/index.css"],"names":[],"mappings":"AAAA;EACC,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,qBAAA;EACA,8BAAA;EACA,mDAAA;AACD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;AAAD;;AAGA;EACC,oCAAA;EACA,uBAAA;EACA,yBAAA;AAAD;;AAGA;EACC,WAAA;AAAD;;AAGA;EACC,oCAAA;EACA,uBAAA;AAAD;;AAGA;EACC,aAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;AAAD;;AAGA;EACC,WAAA;AAAD;;AAGA;EACC,sBAAA;AAAD;;AAGA;EACC,uBAAA;AAAD;;AAGA;EACC,oBAAA;AAAD","sourcesContent":[".image-block .upload-container {\r\n\tmargin: 0 0.5rem;\r\n\tdisplay: block;\r\n\tborder: 2px solid rgba(200 200 200 /1);\r\n\tborder-radius: 0.5rem;\r\n\tbackground: rgba(255 255 255 / 1);\r\n\tbackground: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAEtJREFUKFOF0NEJACAIBFDbQ/cfTPe4MDCiNO9THio3AICamBmNDjpi5j8M5AfLjScq4Y1SmKEHOhKR9J09rDZFcwt2aJ1WVXhPXSYTRUaPHj5D3QAAAABJRU5ErkJggg==);\r\n\r\n}\r\n\r\n.image-block .upload-container .upload-dropzone {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tgap: 1rem;\r\n\tpadding: 2rem;\r\n}\r\n\r\n.image-block .upload-container .upload-dropzone .upload-dropzone-picture {\r\n\tbackground: rgba(255 255 255 / 0.8);\r\n\tpadding: 0.25rem 0.5rem;\r\n\tcolor: rgb(100 100 100);\t\r\n}\r\n\r\n.image-block .upload-container .upload-dropzone .upload-dropzone-picture svg {\r\n\twidth: 2rem;\r\n}\r\n\r\n.image-block .upload-container .upload-dropzone .upload-dropzone-text {\r\n\tbackground: rgba(255 255 255 / 0.8);\r\n\tpadding: 0.25rem 0.5rem;\r\n}\r\n\r\n.image-block .upload-container .upload-element {\r\n\tdisplay: none;\r\n}\r\n\r\n.image-block .image-container {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.image-block .image-container.stretched .image-element {\r\n\twidth: 100%;\r\n}\r\n\r\n.aligner--align-left .image-container {\r\n\tjustify-content: start;\r\n}\r\n\r\n.aligner--align-center .image-container {\r\n\tjustify-content: center;\r\n}\r\n\r\n.aligner--align-right .image-container {\r\n\tjustify-content: end;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
